export default __webpack_public_path__ + "static/media/LolChampionGalleryImg_4.68c73b56.png";